import { Outlet } from 'react-router'

export const AuthAreaLayout = () => {
  return (
    <>
      <Outlet />
    </>
  )
}
